import { AUTH_CHANGED_EVENT } from "../context/CartContext";
import { markJustLoggedOut } from "../utils/biometricLogin";
import { clearRememberedRedirect } from "../utils/authRedirect";

const API = process.env.REACT_APP_API_BASE_URL;

export const authProvider = {
  login: async ({ username, password }) => {
    const res = await fetch(`${API}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ identifier: username, password }), // 👈
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.error || 'Login fallito');
    }
    localStorage.setItem('token', data.token);
    window.dispatchEvent(new CustomEvent(AUTH_CHANGED_EVENT,{detail:{reason:'login'}}));
    return;
  },

  logout: () => {
    localStorage.removeItem('token');
    clearRememberedRedirect(); // niente "pagina richiesta" residua
    // Logout esplicito: sospende SOLO l'auto-trigger biometrico al prossimo
    // arrivo su LoginPage (il bottone FaceID/impronta manuale resta attivo).
    markJustLoggedOut();
    window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
    return Promise.resolve();
  },

  checkAuth: async () => {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No token');
    const res = await fetch(`${API}/api/auth/userinfo`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error('Auth check failed');
    const user = await res.json();
    if (!['admin', 'fornitore'].includes(user.role)) {
      throw new Error('Ruolo non autorizzato');
    }
    localStorage.setItem('userRole', user.role);
    return;
  },

  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getPermissions: async () => {
    return localStorage.getItem('userRole') || 'user';
  },

  getIdentity: async () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    const res = await fetch(`${API}/api/auth/userinfo`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    const user = await res.json();
    return {
      id: user.id,
      fullName: user.name,
      role: user.role,
    };
  },
};
